import { useContext, useEffect, useRef } from "react";
import { BreadcrumbContext } from "./breadcrumbContext";

export function useBreadcrumbOverrides(overrides: Record<string, string>) {
  const { setOverrides } = useContext(BreadcrumbContext);
  const serialized = JSON.stringify(overrides);
  const prevSerialized = useRef(serialized);

  useEffect(function syncOverrides() {
    if (prevSerialized.current !== serialized) {
      prevSerialized.current = serialized;
    }
    setOverrides(overrides);
    return function cleanup() {
      setOverrides({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized, setOverrides]);
}
